import React from "react";
import { Box } from "@material-ui/core";
import { PaperTabLayout } from "frontend/src/ui/paper-tab-layout";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { DeviceSettings } from "./device-settings";
import { DeactivateDevice } from "./deactivate-device";
import { ControlDevice } from "./control-device";
import { DeviceInfo } from "./device-info";
import { usePageDeviceId } from "./model.new";
import { EditDeviceVolume } from "./edit-device-volume";
var Page = function () {
    var id = usePageDeviceId();
    var tabs = [
        {
            label: "Управление",
            node: (React.createElement(Box, null,
                React.createElement(DeviceInfo, { id: id }),
                React.createElement(Box, { mt: 1 },
                    React.createElement(ControlDevice, { id: id })),
                React.createElement(Box, { mt: 1 },
                    React.createElement(EditDeviceVolume, { id: id })),
                React.createElement(Box, { mt: 1 },
                    React.createElement(DeactivateDevice, { id: id })))),
        },
        {
            label: "Настройки",
            node: React.createElement(DeviceSettings, { id: id }),
        },
    ];
    return React.createElement(PaperTabLayout, { tabs: tabs, keepMounted: true, mobileVariant: "fullWidth" });
};
export var DeviceSettingsPage = function () {
    return (React.createElement(BusinessOwnerLayout, null,
        React.createElement(Page, null)));
};
